<template>
    <article class="tarjeta" :class="{'tarjeta--destacada': destacada}">
        <div class="tarjeta__cabecera">
            <div class="tarjeta__sello" :class="{'tarjeta__sello--mal': !aprobado}">
                <v-icon>{{ aprobado ? 'workspace_premium' : 'school' }}</v-icon>
            </div>
            <div>
                <h3 class="tarjeta__titulo">{{ curso.curso }}</h3>
                <span class="tarjeta__estado" :class="aprobado ? 'tarjeta__estado--bien' : 'tarjeta__estado--mal'">
                    {{ aprobado ? 'Aprobado' : 'Reprobado' }}
                </span>
                <span class="tarjeta__estado tarjeta__estado--espera ml-1" v-if="destacada">Registro buscado</span>
            </div>
        </div>

        <ul class="tarjeta__datos">
            <li>
                <v-icon>event</v-icon>
                <span>{{ curso.fecha_inicio | fechaESP }} – {{ curso.fecha_finalizacion | fechaESP }}</span>
            </li>
            <li v-if="Number(curso.horas_curso)">
                <v-icon>schedule</v-icon>
                <span>{{ Number(curso.horas_curso) }} horas</span>
            </li>
            <li v-if="curso.tutor">
                <v-icon>person</v-icon>
                <span>Tutor: {{ curso.tutor }}</span>
            </li>
            <li>
                <v-icon>grade</v-icon>
                <span>
                    Nota <strong>{{ nota }}</strong>
                    <template v-if="curso.promocion"> · Promoción <strong>{{ curso.promocion }}</strong></template>
                </span>
            </li>
            <li v-if="curso.registro">
                <v-icon>tag</v-icon>
                <span>Registro <strong>{{ curso.registro }}</strong></span>
            </li>
        </ul>

        <v-btn block depressed color="primary" v-if="aprobado" @click="$emit('descargar', curso)">
            <v-icon left>download</v-icon>
            Descargar certificado
        </v-btn>
        <div class="tarjeta__aviso" v-else>
            <v-icon small>info</v-icon> Un curso reprobado no genera certificado.
        </div>
    </article>
</template>

<script>
/** Tarjeta de un curso del historial del participante. Emite "descargar" con el curso. */
export function notaLegible(curso) {
    const n = Number(curso.nota);
    return isNaN(n) ? (curso.nota || "—") : n.toLocaleString("es-HN", {maximumFractionDigits: 2});
}

export default {
    name: "TarjetaCurso",
    props: {
        curso: {type: Object, required: true},
        destacada: {type: Boolean, default: false},
    },
    computed: {
        aprobado() {
            return this.curso.aprobado == true;
        },
        nota() {
            return notaLegible(this.curso);
        },
    },
}
</script>

<style lang="scss" scoped>
@import "./tarjetas.scss";
</style>
